<template>
  <div class="registration-box">
    <div class="registration-form">
      <!--使用draggable组件-->
      <draggable
        v-model="formArr"
        chosenClass="chosen"
        forceFallback="true"
        group="form"
        animation="1000"
        :move="onMove"
        @end="$emit('signUpsChange', formArr)"
      >
        <transition-group>
          <div class="item" v-for="item in formArr" :key="item.code">
            <div style="width: 18px">
              <Icon
                v-if="item.code !== 'name' && item.code !== 'phone' && item.code !== 'unit'"
                type="md-move"
                color="#000"
                style="margin-right: 5px"
              />
            </div>
            <FormItem
              class="form-item"
              :label="item.value"
              v-if="item.code === 'gender'"
            >
              <RadioGroup v-model="item.content">
                <Radio label="1" disabled>男</Radio>
                <Radio label="0" disabled>女</Radio>
              </RadioGroup>
            </FormItem>
            <FormItem
              class="form-item"
              :label="item.value"
              v-else-if="item.code === 'highestedu'"
            >
              <Select v-model="item.content" disabled>
                <Option :value="1"></Option>
              </Select>
            </FormItem>
            <FormItem
              class="form-item"
              :label="item.value"
              v-else-if="item.code === 'birth'"
            >
              <DatePicker
                type="date"
                v-model="item.content"
                style="width: 100%"
                disabled
              ></DatePicker>
            </FormItem>
            <FormItem
              class="form-item"
              :label="item.value"
              v-else-if="item.code === 'native'"
            >
              <Select
                v-model="item.content"
                style="width: 45%; margin-right: 5px"
                disabled
              >
                <Option value="1"></Option>
              </Select>
              <Select v-model="item.content" style="flex: 1" disabled>
                <Option value="1"></Option>
              </Select>
            </FormItem>
            <FormItem
              class="form-item"
              :label="item.value"
              v-else-if="item.code === 'title'"
            >
              <Select
                v-model="item.content"
                style="width: 100px; margin-right: 5px"
                disabled
              >
                <Option value="1"></Option>
              </Select>
              <Input style="flex: 1" v-model="item.content" disabled />
            </FormItem>
            <FormItem class="form-item" :label="item.value" v-else>
              <Input v-model="item.content" style="width: 100%" disabled />
            </FormItem>
            <Checkbox
              :disabled="item.code == 'name' || item.code == 'phone' || item.code == 'unit'"
              v-model="item.must"
              style="margin: 0 5px 0 15px"
              :true-value="1"
              :false-value="0"
              >必填</Checkbox
            >
            <div style="width: 18px">
              <Icon
                v-if="item.code !== 'name' && item.code !== 'phone' && item.code !== 'unit'"
                type="md-remove-circle"
                size="18"
                color="red"
                style="cursor: pointer"
                @click="deleteItem(item)"
              />
            </div>
          </div>
        </transition-group>
      </draggable>
    </div>
    <div class="registration-button">
      <h3>可添加标单项</h3>
      <div class="button-box">
        <div
          v-for="item in exampleArr"
          :key="item.code"
          :class="['button', item.isChoose ? 'button-actice' : '']"
          @click="chooseItem(item)"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
export default {
  name: "registrationForm",
  //注册draggable组件
  components: {
    draggable,
  },
  props: ["signUps"],
  data() {
    return {
      name: "",
      phone: "",
      contentArr: [],
      //定义要被拖拽对象的数组
      formArr: [],
      exampleArr: [],
    };
  },
  watch: {
    signUps: {
      handler(newVal) {
        this.formArr = [...newVal];
        this.exampleArr.forEach((item) => {
          item.isChoose = newVal.some((i) => i.code === item.code);
        });
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.getInsertInfo();
  },
  methods: {
    onMove(e, originalEvent) {
      //不允许停靠和停靠
      return (
        e.relatedContext.element.code !== "name" &&
        e.draggedContext.element.code !== "name" &&
        e.relatedContext.element.code !== "phone" &&
        e.draggedContext.element.code !== "phone" &&
        e.relatedContext.element.code !== "unit" &&
        e.draggedContext.element.code !== "unit"
      );
    },
    // 获取报名表单添加项
    async getInsertInfo() {
      const res = await this.$apis.userServe.getInsertInfo();
      res.content.signUpList.forEach((item) => {
        if (item.code !== "phone" && item.code !== "name" && item.code !== "unit") {
          item.isChoose = false;
          this.exampleArr.push(item);
        }
      });
    },
    // 选择报名表单项
    chooseItem(item) {
      if (item.isChoose) {
        this.formArr = this.formArr.filter((i) => i.code !== item.code);
      } else {
        this.formArr.push({
          code: item.code,
          value: item.name,
          must: 1,
        });
      }
      item.isChoose = !item.isChoose;
      this.$emit("signUpsChange", this.formArr);
    },
    // 删除报名表单项
    deleteItem(item) {
      this.formArr = this.formArr.filter((i) => i.code !== item.code);
      this.exampleArr.forEach((i) => {
        if (i.code === item.code) {
          i.isChoose = false;
        }
      });
      this.$emit("signUpsChange", this.formArr);
    },
  },
};
</script>

<style lang="scss" scoped>
.registration-box {
  display: flex;
  width: 100%;
  .registration-form {
    width: 450px;
    .item {
      display: flex;
      align-items: center;
      margin-bottom: 21px;
      &:last-child {
        margin-bottom: 0;
      }
      .form-item {
        flex: 1;
      }
    }
    .chosen {
      cursor: move !important;
      &::v-deep .ivu-form-item-label {
        cursor: move;
      }
    }
  }
  .registration-button {
    flex: 1;
    margin-left: 20px;
    padding-left: 34px;
    border-left: 1px solid #dcdcdc;
    h3 {
      font-size: 14px;
      font-weight: 500;
      color: #333333;
    }
    .button-box {
      display: flex;
      flex-wrap: wrap;
      margin-top: 30px;
      width: 100%;
      .button {
        margin: 0 20px 10px 0;
        width: 70px;
        color: #666666;
        cursor: pointer;
      }
      .button-actice {
        color: #1876f0;
      }
    }
  }
}
</style>